import { lazy } from 'react'

import { type IBreadcrumbsProps } from '@webapp/core/components/Breadcrumbs'
import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const QuickBooksDesktopViewChunk = lazy(() =>
  import('@webapp/platform/integrations/feature-sets/QuickBooksDesktopView').then(
    ({ QuickBooksDesktopView }) => ({
      default: QuickBooksDesktopView,
    })
  )
)

export const QuickBooksDesktopPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  const pageTitle = intl.formatMessage(messages.pageTitle)

  const breadcrumbs = [
    {
      link: url('SettingsPage'),
      name: intl.formatMessage(messages.settingsTitle),
    },
    {
      link: url('IntegrationsPage'),
      name: intl.formatMessage(messages.integrationsTitle),
    },
    {
      name: pageTitle,
      escapeCaseFormatting: true,
    },
  ] satisfies IBreadcrumbsProps['crumbs']

  return (
    <Page pageTitle={pageTitle} breadcrumbs={breadcrumbs}>
      <QuickBooksDesktopViewChunk />
    </Page>
  )
}
